export const getTaxInfo = (taxRate: number, fee: number): string =>
  taxRate > 0 && fee > 0 ? ` (includes ${taxRate * 100}% SST tax)` : '';
